/** サポート連絡先（全アプリ共通） */
export const SUPPORT = {
  email: 'support@jiayin.jp',
  phone: '03-XXXX-XXXX',
  hours: '平日 9:00 - 18:00',
} as const;
